import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { StructureCommentsVM } from './StructureCommentsVM';
import { formatDate } from 'cd-eft/utils/formatDate';
import { Form, FormGroup, Label, Col } from 'reactstrap';
import { ActionsMenu } from '../../Design/common/ActionsMenu';
import stores from 'cd-eft/models/Stores';
import { DesignCommentAdd, DesignCommentCloseButtons, DesignCommentDeletePopup, DesignCommentEditForm, DesignCommentReadAndEdit, DesignCommentReadForm } from '../common/CommentInputs';
const libraryStore = stores.AppStore.projectsLibraryStore;

const StructureCommentsComponent = (props) => {
    const vm = useRef(new StructureCommentsVM(props)).current;

    return (
        <>
            <div className="sub-container">
                {(props.currentStructureList && (props.currentStructureList.length > 0)) ?
                    <div className="action-menu-wrapper">
                        <ActionsMenu i={'structure-comments'} item="item" colorWhite={true} elementActions={vm.elementActions}>Action</ActionsMenu>
                    </div>
                    : <></>}

                <div className="comments-container">
                    {(props.currentStructureList && (props.currentStructureList.length > 0)) ?
                        libraryStore.structureComments.length === 0 && !vm.addFormActive && (
                            <div className="no-comment">
                                <p>No Design Comment</p>
                            </div>
                        ) :
                        <div className="no-comment">
                            <p>No structures available to add design comments</p>
                        </div>}
                    {/********************  Create Comments Form   ********************/}
                    {vm.addFormActive && (
                        <Form
                            fluid={+true}
                            onSubmit={vm.handleSubmit}
                        >
                            <FormGroup>
                                <DesignCommentAdd
                                    selectId={'designTypeAndStructureName'}
                                    defaultValue={vm.createStructureDesignCommentForm.designTypeAndStructureName}
                                    onChange={vm.handleInput}
                                    addOrEdit={'add'}
                                    errorClassFunction={vm.errorClass}
                                    label={'Select Structure'}
                                    optionList={props.currentStructureList}
                                    validationArray={vm.formValidation.formErrors}
                                />
                                <Col>
                                    <Label for="createdBy">
                                        <div className="info">
                                            <div className="workflowstep">
                                                <strong>{vm.createStructureDesignCommentForm.designTypeAndStructureName}</strong>
                                            </div>
                                            <div className="name capitalize">
                                                <strong>{vm.createStructureDesignCommentForm.commentAuthor.split('@')[0].replace('.', ' ')}</strong>
                                            </div>
                                            <div className="date">{formatDate(Date.now())}</div>
                                        </div>
                                    </Label>
                                </Col>
                                <Col>
                                    <textarea
                                        className={`comment-textarea ${vm.errorClass('projectComment')}`}
                                        name="projectComment"
                                        value={vm.createStructureDesignCommentForm.projectComment}
                                        placeholder="add comment"
                                        autoFocus
                                        onChange={vm.handleInput}
                                        rows={4}
                                        wrap="soft"
                                    />
                                    <span className="usa-error-message" id="projectComment-error--message" role="alert">
                                        <div>{vm.formValidation.formErrors['projectComment']}</div>
                                    </span>
                                </Col>
                            </FormGroup>
                        </Form>
                    )}
                    {vm.addFormActive && (
                        <div className="d-flex justify-content-end usa-buttons">
                            <button className="usa-button usa-button--outline" onClick={vm.cancelComment}>
                                Close
                            </button>
                            <button className="usa-button" onClick={vm.createComment}>
                                Save
                            </button>
                        </div>
                    )}
                    {/********************  End of Create Comments Form   ********************/}

                    {libraryStore.structureComments &&
                        libraryStore.structureComments.map((comment, i) => {
                            return (
                                <DesignCommentReadAndEdit
                                    vm={vm}
                                    comment={comment}
                                    index={i}
                                    readFormVarName='designTypeAndStructureName'
                                    DesignCommentAddProps={{
                                        selectId: 'designTypeAndStructureName',
                                        defaultValue: comment.designTypeAndStructureName,
                                        onChange: (e) => { vm.handleInputChange(e, i) },
                                        addOrEdit: 'edit',
                                        errorClassFunction: vm.errorClass,
                                        label: 'Select Structure',
                                        optionList: props.currentStructureList,
                                        validationArray: vm.formValidation.formErrors
                                    }}
                                />
                            );
                        })}
                </div>
                <DesignCommentCloseButtons vm={vm} />

                {/********************  End of Edit Comments Form   ********************/}

                {/********************  Delete Comments Popup   ********************/}
                <DesignCommentDeletePopup
                    vm={vm}
                    commentList={libraryStore.structureComments}
                    nameHeader='Structure Name'
                />
                {/********************  Delete Comments Popup   ********************/}
            </div>
            {/*                     </Accordion>
                </div>
            )} */}
        </>
    );
};
export const StructureComments = observer(StructureCommentsComponent);
